import React from 'react';
import PropTypes from 'prop-types';
import logo from './img/logo.svg';
import './Header.css';
import Mission from './Mission';

interface Props {
  withMission: boolean,
  brand: string
}

function Header(props: Props): JSX.Element {
  const { withMission, brand } = props;
  const mission = withMission ? <Mission /> : null;

  return (
    <header className="header">
      <div className="header-inner">
        <img className="logo" src={logo} alt={brand} />
        {mission}
      </div>
    </header>
  );
}

Header.propTypes = {
  withMission: PropTypes.bool,
  brand: PropTypes.string,
};

Header.defaultProps = {
  withMission: false,
  brand: null,
};

export default Header;
